import React, { useCallback, useEffect } from 'react'
import { Spin } from 'antd'

import { Page } from '../../../common/components/sections'
import { APP_ROUTES } from '../../../common/constants'
import { showErrorNotification } from '../../../common/helpers'
import { useDocumentTitle, useLoggedInUser } from '../../../common/hooks'

import { useUpdateUserSettingsMutation } from '../../hooks'
import { UserSettingsForm } from '../forms'

const UserSettingsPage = () => {
  useDocumentTitle(APP_ROUTES.SETTINGS.name)
  const { id, settings } = useLoggedInUser()

  const [updateUserSettings, { isLoading, error }] =
    useUpdateUserSettingsMutation()

  const handleSave = useCallback(
    formValues =>
      updateUserSettings({
        userId: id,
        settings: formValues,
      }),
    [id, updateUserSettings],
  )

  useEffect(() => {
    if (error) {
      showErrorNotification({ title: 'Update settings', description: error })
    }
  }, [error])

  return (
    <Page>
      {isLoading ? (
        <Spin />
      ) : (
        <UserSettingsForm onSubmit={handleSave} settings={settings} />
      )}
    </Page>
  )
}

export default UserSettingsPage
